import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5" }
const _hoisted_2 = { class: "bodyTEXT" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref, computed } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { LABELS } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { postAddUserData, postDeleteUserData, postEditUserData } from '@/services/RAOS/Admin';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDialog',
  props: {
    itemObject  : { type: Object, required:true }
},
  emits: ['closeDialog'],
  setup(__props, { emit: __emit }) {

const store = useStore();

/********************************
 *********** VUETIFY ************
 *******************************/
const {xs,smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const props = __props
const emits = __emit;

const finalItem = computed(() => props.itemObject);

const id = ref(finalItem.value.id);
const nombre = ref(finalItem.value.nombre);
const asignado = ref(finalItem.value.asignado);
const turno = ref(finalItem.value.turno);
const typeDialog = ref(finalItem.value.typeDialog);


const itemList   = computed(()=>store.state.arrayListItems.map( (item:any) => item.ip));

const newAdd        = ref(false);

const disableEDTbtn = computed( ()=>
    (nombre.value === finalItem.value.nombre &&
    asignado.value === finalItem.value.asignado && turno.value === finalItem.value.turno)
)

const disableAddbtn = computed( ()=>
    (nombre.value === '' || asignado.value === '' || turno.value === '')
)


const params        = ref({});
const valid         = ref(true);
const fieldRules    = computed ( () => [ (v:string) => !!v ||  t('labels.error.required') ]);

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Send all Form Data to API
 */


async function addNewUser(){
    newAdd.value    = true;

    await getParams();

    const allData = await postAddUserData(params.value)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        store.dispatch('getAllUsers');
        store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.addApis'), valor : true});

    }
}

async function editUser(){

    newAdd.value    = false;

    await getParams();
    
    const allData = await postEditUserData(params.value)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        store.dispatch('getAllUsers');
        store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.addApis'), valor : true});

    }
}

const deleteUser = async () => {

    newAdd.value = false;
    
    await getParams();

    const allData = await postDeleteUserData(params.value)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){

        store.dispatch('getAllUsers');
        store.commit('showSnackBar', {type: LABELS.add, msg: t('snackbar.addApis'), valor : true});
        emitDialogClose()
    }
    
}


const getParams = async () => {
    
    params.value = {
        id : newAdd.value ? null : id.value,
        nombre : nombre.value,
        asignado : asignado.value,
        turno : turno.value
    }
}

const emitDialogClose = () => {
    emits('closeDialog');
}
     


return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!

  return (typeDialog.value === 'delete')
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        color: "bgtopology",
        width: "90%",
        class: "defaultCard",
        style: {"margin":"0 auto !important"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('title.delUser')), 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('labels.bodyDialog.deleteUser')) + " " + _toDisplayString(nombre.value), 1),
          _createVNode(_component_v_divider, { class: "my-4" }),
          _createVNode(_component_v_row, {
            justify: _unref(smAndDown) ? 'center' : 'end',
            class: "ma-0 mt-6 mb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: _normalizeClass(_unref(smAndDown)?'ma-2':'mx-2'),
                color: "success",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteUser())),
                block: _unref(xs)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('buttons.yes')), 1)
                ]),
                _: 1
              }, 8, ["class", "block"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass(_unref(smAndDown)?'ma-2':'mx-2'),
                color: "red",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emitDialogClose())),
                block: _unref(xs)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('buttons.not')), 1)
                ]),
                _: 1
              }, 8, ["class", "block"])
            ]),
            _: 1
          }, 8, ["justify"])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_sheet, {
        key: 1,
        color: "bgtopology",
        width: "100%",
        class: "defaultCard"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "ma-0",
            justify: "space-between",
            style: {"align-items":"center !important"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "10"
              }, {
                default: _withCtx(() => [
                  (typeDialog.value === 'add')
                    ? (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 0,
                        color: "transparent"
                      }, {
                        default: _withCtx(() => [
                          (_unref(xs))
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(t)('title.addUser')), 1))
                            : (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)('title.addUser')), 1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (typeDialog.value === 'edit')
                    ? (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 1,
                        color: "transparent"
                      }, {
                        default: _withCtx(() => [
                          (_unref(xs))
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_unref(t)('title.edtUser')), 1))
                            : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_unref(t)('title.edtUser')), 1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    variant: "plain",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emitDialogClose()))
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "mt-4 mb-7" }),
          _createVNode(_component_v_form, {
            modelValue: valid.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((valid).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: nombre.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nombre).value = $event)),
                        label: _unref(t)('labels.name') + ' *',
                        variant: "underlined",
                        density: "compact",
                        rules: fieldRules.value
                      }, null, 8, ["modelValue", "label", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: asignado.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((asignado).value = $event)),
                        items: itemList.value,
                        label: _unref(t)('labels.assigned') + ' *',
                        variant: "underlined",
                        density: "compact",
                        rules: fieldRules.value
                      }, null, 8, ["modelValue", "items", "label", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: turno.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((turno).value = $event)),
                        items: ['diurno','nocturno'],
                        label: _unref(t)('labels.turn') + ' *',
                        variant: "underlined",
                        density: "compact",
                        rules: fieldRules.value
                      }, null, 8, ["modelValue", "label", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (typeDialog.value === 'edit')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (editUser())),
                    disabled: (!valid.value && valid.value !== null && valid.value !== undefined) || (disableEDTbtn.value),
                    class: _normalizeClass(_unref(smAndDown) ? 'mt-3' : 'mt-10'),
                    "prepend-icon": "mdi-pencil",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('buttons.change' )), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "class"]))
                : _createCommentVNode("", true),
              (typeDialog.value === 'add')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (addNewUser())),
                    disabled: (!valid.value && valid.value !== null && valid.value !== undefined) || disableAddbtn.value,
                    class: "mt-10",
                    "prepend-icon": "mdi-check-circle",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('buttons.add' )), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }))
}
}

})